import type { EnumWeatherCondition } from '../../../utils/weatherConditionToIcon'
import { weatherConditionToIcon } from '../../../utils/weatherConditionToIcon'

export const WeatherIcon = (props: { weatherCondition?: string | null }) => {
  const weatherCondition = props.weatherCondition as EnumWeatherCondition
  const Icon = weatherConditionToIcon(weatherCondition)

  return <span css={{ fontSize: 60 }}>{Icon}</span> ?? <></>
}
